<mat-select #matSl multiple [formControl]="selectFormControl" (openedChange)="openedChange($event)" placeholder="All">
    <div class="p-3">
        <input
            #inputField
            matInput
            [formControl]="inputControl"
            placeholder="{{'Enter more than '+minCharacters+' letters to start searching'}}"
            tabindex="-1"
            (keydown)="$event.stopPropagation()"
        />
        <div class="selection-btns">
            <button (click)="selectAll()" class="selection-btns" type="button">Select All</button>
            <button (click)="removeAll()" class="selection-btns" type="button">De-Select All</button>
        </div>
    </div>
    <mat-option disabled *ngIf="(filteredOptions | async)?.length == 0">-</mat-option>
    <div class="mb-4">
        <mat-option *ngFor="let option of filteredOptions | async"
            [value]="option[dataIdKey]"
            (onSelectionChange)="selectionChange($event, option)"
        >
            {{ option[dataValueKey] }}
        </mat-option>
    </div>
    <!-- <button class="dropdown-close-btn" type="button">DONE</button> -->
</mat-select>
<div *ngIf="configOption.toolTipType == 'items' && bottomToolTip.total.length > 0" [ngClass]="{'fully-open': showAllToolTip}" class="bottom-tooltip">
    <div *ngIf="bottomToolTip.total.length > 4" class="selected-item show-more-btn" (click)="showAllToolTip=!showAllToolTip">
        <span>{{showAllToolTip ? '-':'+'}}{{(bottomToolTip.total | slice:4).length}}</span>
    </div>
    <div class="selected-items-container">
        <ng-container *ngFor="let item of bottomToolTip.items">
            <div class="selected-item">
                <span>{{item[dataValueKey]}}</span>
                <button (click)="onBottomToolTipRemove(item)" type="button">
                    <svg fill="#000000" width="12px" height="12px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z" fill-rule="evenodd"/>
                    </svg>
                </button>
            </div>
        </ng-container>
    </div>
</div>
<app-tooltip *ngIf="!configOption.toolTipType || configOption.toolTipType != 'items'" [data]="toolTipData"></app-tooltip>